export default __webpack_public_path__ + "static/summer_containers72-dd40dd51a91facd9186829a392246ec3.webp";